import { fetchJson } from '../../../../../store/fetch';
import { translateKey } from '../../../../../translate';
import { ListTable, TableBody, TableData, TableHead, TableHeader, TableRow } from '../../../../elements/common';
import { Component } from '../../../../elements/Component';
import { FormSection } from '../../../../elements/forms/formSection/FormSection';

interface ITxcsMedicationsListProps {
    onContentLoaded?: (hasContent: boolean) => Promise<void>;
    requestId: string;
}

interface ITxcsMedicationsListState {
    txcsMedications?: ITxcsMedication[];
}

interface ITxcsMedication {
    dosageInstruction: string | null;
    endDateText: string | null;
    id: string;
    name: string | null;
    quantity: string | null;
    reasonForUse: string | null;
    startDateText: string | null;
}

export class TxcsMedicationsList extends Component<ITxcsMedicationsListProps, ITxcsMedicationsListState> {
    public async componentDidMount() {
        const results = await fetchJson(`/api/requests/${this.props.requestId}/txcsMedications`, 'GET');
        await this.setState({ txcsMedications: results.json.items });

        if (this.props.onContentLoaded) {
            this.props.onContentLoaded(
                this.state.txcsMedications !== undefined && this.state.txcsMedications.length > 0
            );
        }
    }

    public render() {
        if (this.state.txcsMedications && this.state.txcsMedications.length > 0) {
            return (
                <FormSection title={translateKey('medications.medication')}>
                    <ListTable>
                        <TableHead>
                            <TableRow>
                                <TableHeader>{translateKey('common.type')}</TableHeader>
                                <TableHeader>{translateKey('medications.quantity')}</TableHeader>
                                <TableHeader>{translateKey('medications.frequency')}</TableHeader>
                                <TableHeader>{translateKey('common.fromCapitalized')}</TableHeader>
                                <TableHeader>{translateKey('common.toCapitalized')}</TableHeader>
                                <TableHeader>{translateKey('medications.reason')}</TableHeader>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.txcsMedications.map((txcsMedication) => (
                                <TableRow key={txcsMedication.id}>
                                    <TableData>{txcsMedication.name}</TableData>
                                    <TableData>{txcsMedication.quantity}</TableData>
                                    <TableData>{txcsMedication.dosageInstruction}</TableData>
                                    <TableData>{txcsMedication.startDateText}</TableData>
                                    <TableData>{txcsMedication.endDateText}</TableData>
                                    <TableData>{txcsMedication.reasonForUse}</TableData>
                                </TableRow>
                            ))}
                        </TableBody>
                    </ListTable>
                </FormSection>
            );
        } else {
            return null;
        }
    }
}
